import { request } from '@/shared/api/request'

export const addWorkPlaceGroup = (data) => {
	return request({
		method: 'POST',
		url: `staff/workPlace/groupAdd`,
		data: data,
	})
}
